export const APPROVED_FILE_TYPES = new Set([
  '3gp',
  'aac',
  'ai',
  'aiff',
  'avi',
  'bbl',
  'csv',
  'doc',
  'docx',
  'dwg',
  'eps',
  'epub',
  'fdx',
  'flac',
  'flv',
  'gif',
  'iba',
  'ibooks',
  'jpeg',
  'jpg',
  'key',
  'ltx',
  'm4a',
  'm4v',
  'mkv',
  'mobi',
  'mov',
  'mp3',
  'mp4',
  'mpg',
  'mpp',
  'mpx',
  'mus',
  'odt',
  'ogg',
  'pdf',
  'png',
  'ppt',
  'pptx',
  'psd',
  'rtf',
  'sib',
  'svg',
  'tex',
  'tif',
  'tiff',
  'txt',
  'usdz',
  'vcf',
  'vdx',
  'vsd',
  'vss',
  'vst',
  'vsx',
  'wav',
  'webm',
  'wma',
  'wpd',
  'wpf',
  'xls',
  'xlsx',
  'zip'
])
